module.exports = __webpack_public_path__ + "static/media/arrow-right.50795a12.svg";